import store from "../store";
var visitor = {
  "Rooms": "DEFAULT",
  "Meeting": 0,
  "ClientType": 1,
};
var _commSocket;
var vm;
var isNotice = true;
var servicesTipIndex = 0;
export const webkitLoad = (openCallBack, _visitior, _vm) => {
  /*    if (_commSocket) {
          _commSocket.close(true);
          _commSocket = null;
      }*/
  if (_visitior) {
    $.extend(visitor, _visitior);
  }
  if (_vm) {
    vm = _vm
  }
  _commSocket = wsc.getWSC({
    //websocket地址
    servicePath: store.state.app.servicePath,
    //终端mac
    mac: "manage" + randomCode(),
    onOpen: function (that) {
      if (openCallBack)
        openCallBack(that);
      that.receive();
    }
    , onMess: function (evt) {

      if (evt.data) {

        try {
          var jsonCommand = $.parseJSON(evt.data);
          if (jsonCommand != null) {
            var type = jsonCommand.CommandData.Data.DataMarking; //type头部
            var data = jsonCommand.CommandData.Data.DataContent; //data具体数据
            var commandData = jsonCommand.CommandData.Data;
            // 发送命令者人员id
            var visitorUserId = jsonCommand.CommandHeader.Visitor.User;
            //console.log(commandData);

            wsOnMessage(type, data, visitorUserId);
          }
        } catch (e) {
          //console.log(e)
        }
      }
    }
    , onClose: function () {
    }
    , onDisconnect: function (flag) {
      if (!flag) {
        vm.$Message.error({content: "抱歉，WebSocket连接失败，请检查网络或查看服务器是否开启，并刷新重试", duration: 10, closable: true});
      }
    }
  });

  _commSocket.connect(visitor);
  _commSocket.receive();
};
export {_commSocket};

function wsOnMessage(type, data, visitorUserId) {

  var dataObject = "";
  if (data != "") {
    try {
      dataObject = $.parseJSON(decodeURI(data))
    } catch (e) {
      dataObject = data;
    }
  }

  if (type) {
    //判断当前页面
    var hrefInfo = window.location.href;//获取页面地址信息
    var pageName = hrefInfo.substring(hrefInfo.lastIndexOf("/") + 1);
    var isMeeting = pageName.indexOf("=") < 0 ? true : parseInt(pageName.substring(pageName.indexOf("=") + 1)) == dataObject.meetingId;

    switch (type) {
      case "shoutReload": //接收呼叫
        if (pageName.toLowerCase().indexOf("control-page") >= 0 && isMeeting) {
          let person = vm.$store.state.app.ControlCenter.getPersonData(dataObject.userId);
          person.objectState.ECall = 1;
          //修改人员图标
          $(vm.$store.state.app.ControlCenter.divDefaultNodeArea).children("div[data-type='chair'][user=" + dataObject.userId + "]").children("div:first").addClass("call");
          // vm.$store.state.app.audioObj.play();
        }
        if (pageName.toLowerCase().indexOf("services-list") >= 0 && isMeeting) {
          let nowVue = vm.$store.state.app.nowVue;
          nowVue.dataList();
          // vm.$store.state.app.audioObj.play();
        }
        // 判断当前页在呼叫列表不做弹出
        if (pageName.toLowerCase().indexOf("services-list")<0 && isMeeting){
          // 作为弹框唯一的值
          servicesTipIndex++;
          var tipIndex = servicesTipIndex;
          vm.$Notice.info({
            top: 50,
            duration:6,
            title: '呼叫提醒',
            name: 'servicesTip'+ servicesTipIndex,
            render: h => {
              return h('span', [
                  h('div',{
                    style: {
                      cursor: 'pointer',
                      fontSize :"14px",
                      marginBottom :"10px"
                    },
                  },`${dataObject.shoutContent}`),
                  h('a',{
                    style: {
                      cursor: 'pointer'
                    },
                    on:{
                      click:()=>{
                        vm.$router.push({name: 'services-list'});
                        // 关闭点击的弹框
                        vm.$Notice.close('servicesTip'+ tipIndex);
                        // 暂停音频
                        vm.$store.state.app.audioObj.pause();
                        // 音频时间重置为0
                        vm.$store.state.app.audioObj.currentTime = 0;
                      }
                    }
                  }, '点击查看'),
              ])
            }
          });
        }
        vm.$store.state.app.audioObj.play();
      break;
      case "shoutCancel":
        if (pageName.toLowerCase().indexOf("control-page") >= 0 && isMeeting) {
          vm.$app.post("/shoutServer/getUserShouts?a=" + Math.random(), {
            "meetingID": dataObject.meetingId,
            "userID": dataObject.userId
          })
            .then(res => {
              if (res.data.code == 0) {
                if (res.data.data.length <= 0) {
                  var person = vm.$store.state.app.ControlCenter.getPersonData(dataObject.userId);
                  person.objectState.ECall = 0;
                  //修改人员图标
                  $(vm.$store.state.app.ControlCenter.divDefaultNodeArea).children("div[data-type='chair'][user=" + dataObject.userId + "]").children("div:first").removeClass("call");
                }
              } else {
                vm.message("获取人员呼叫列表失败！");
              }
            });
        }
        break;
      case "voteStart":
      case "voteEnd":
        if (pageName.toLowerCase().indexOf("vote-list") >= 0) {
          let nowVue = vm.$store.state.app.nowVue;
          if (nowVue.meetingID) {
            vm.$app.post("/vote/page", {
              pageNo: 1,
              pageSize: 12,
              meetingId: nowVue.meetingID,
              isTiming: ''
            }).then(res => {
              if (res.data.code == 0) {
                nowVue.dataTotal = res.data.data.total;
                nowVue.tableData1 = res.data.data.records;
                nowVue.tableData1.forEach(item => {
                  //进行中的会议不能勾选
                  if (item.vStatus == 1) {
                    nowVue.$set(item, "_disabled", true)
                  }
                });
              } else {
                vm.message("获取投票列表失败！");
              }
            });
          }
        }
        break;
      case "topicStart":
        if (pageName.toLowerCase().indexOf("control-page") >= 0) {
          let nowVue = vm.$store.state.app.nowVue;
          if (dataObject.topicId) {
            nowVue.topicId = dataObject.topicId;
          }
        }
        break;
      case "meetingAudit":
        // 当前人员id
        var userId = parseInt(sessionStorage.getItem("setUserId"));
        // vue指向
        let nowVue = vm.$store.state.app.nowVue;
        // 判断当前人员id是否包含在审批人员集合中
        if (dataObject.userIds.indexOf(userId) !== -1) {
          // 判断是否在我的审核页面中
          if (pageName.toLowerCase().indexOf("meeting-list") >= 0) {
            // 是则刷新审核列表
            window.refreshCurrentPageData();
          } else {
            // 否则弹出跳转提示
            // 枚举对象
            let emums = JSON.parse(sessionStorage.getItem('emums'));
            // 请求审核数量
            vm.$app.post("/notice/unread/classify/count", {noticeTypes: [emums.noticeType.waitAudit]}).then(res => {
              // 判断得到有效数据
              if (res.data.code == 0) {
                // 如果有未读消息则提示
                if (res.data.data.count) {
                  // 提示框
                  vm.$Notice.warning({
                    duration: 5,
                    name: 'auditTip',
                    title: '提醒',
                    render: h => {
                      return h('span', {
                        style: {
                          cursor: 'pointer'
                        },
                        on: {
                          click: () => {
                            // 先设置对应的会议室
                            // 当前的会议室id
                            var meetingRoomId = vm.$store.state.app.meetingRoomId;
                            // 会议室集合
                            var meetingRoomList = vm.$store.state.app.meetingRoomList;
                            // 审核记录中的会议室id集合
                            var roomIds = res.data.data.roomIds;
                            // 判断当前会议室没有在审核记录中的会议室id集合中
                            if (roomIds.indexOf(meetingRoomId) === -1) {
                              let roomNo = "";
                              for (let i = 0; i < meetingRoomList.length; i++) {
                                if (meetingRoomList[i].id == roomIds[0]) {
                                  roomNo = meetingRoomList[i].roomNo;
                                  break
                                }
                              }
                              // 则页面重新选择会议室
                              vm.$misc.editCurrBoardRoom(vm, roomIds[0],roomNo, (res) => {
                                if (res.code == 0) {
                                  meetingRoomList.forEach(el => {
                                    if (el.pkid == roomIds[0] && el.rType == 1) {
                                      vm.$route.query['rType'] = 1
                                    }
                                  });
                                  vm.$store.commit("setMeetingRoomId", res.data.pkid);
                                  vm.$store.commit("setMeetingRoomNo", res.data.roomNo);
                                  //重新获取websocket地址
                                  vm.$misc.getSocketInfo(vm, res => {
                                    if (res.code == 0) {
                                      vm.$store.commit("setServicePath", {
                                        address: res.data.wAddress,
                                        vm: vm
                                      });
                                    } else {
                                      // this.$store.commit("setServicePath", "") ;
                                      vm.$store.commit("setServicePath", {address: "", vm: vm});
                                    }
                                    vm.$store.commit("toggleReload", {
                                      vm: vm, fn: () => {
                                        //如果是在终端切换会议室 也要刷新数据，强制将id改为0
                                        if (vm.$route.query.id) {
                                          vm.$route.query.id = 0;
                                        }
                                      }
                                    });
                                  });
                                }
                                // 跳转到我的审核页面
                                vm.$router.push({
                                  name: 'meeting-list',
                                  // 跳转参数设置是审核页面参数
                                  query: {
                                    // 跳转列表标识，用于返回的时候跳转到那个列表中
                                    jump: "meAudit",
                                  },
                                })
                                // 关闭弹框
                                vm.$Notice.close('auditTip')
                              });
                            } else {
                              // 跳转到我的审核页面
                              vm.$router.push({
                                name: 'meeting-list',
                                // 跳转参数设置是审核页面参数
                                query: {
                                  // 跳转列表标识，用于返回的时候跳转到那个列表中
                                  jump: "meAudit",
                                },

                              })
                              // 关闭弹框
                              vm.$Notice.close('auditTip')
                            }
                          }
                        }
                      }, `您有${res.data.data.count}条待审核会议，请及时处理。`)
                    },
                    onClose: () => {
                      vm.$app.post("/notice/classify/read", {noticeTypes: [emums.noticeType.waitAudit]})
                    }
                  });
                }
              } else {
                vm.$Message.error(res.data.msg);
              }
            });
          }
          break;
        }
        break;
      case "datumSlicingCallback":
        // 如果是此人切图的，则提示切图成功
        var userId = sessionStorage.getItem("setUserId");
        // 会议资料id
        let meetingDatumId = dataObject.meetingDatumId;
        // 是否有当前的资料文件
        var isFile = false;
        // 是否在当前页面
        var isPage = vm.$route.name === "files-list";
        // 判断是否在当前页面
        if (isPage) {
          // 获取
          let nowVue = vm.$store.state.app.nowVue;
          // 循环找到对应的会议资料数据
          for (let i = 0; i < nowVue.tableData1.length; i++) {
            // 每个资料数据
            let meetingDatum = nowVue.tableData1[i];
            // 判断资料页数据等于列表中的
            if (meetingDatum.pkid === meetingDatumId) {
              // 附加是当前的资料文件
              isFile = true;
              break;
            }
          }
        }
        // 判断是否是当前页面并且当前页面有这个资料文件
        var isPageFile = isPage && isFile;
        // 判断上传的文件是当前的人员或则当前页面有这个资料则提示
        if (userId == dataObject.datumUserId || isPageFile) {
          vm.$store.dispatch("globalNotice", {title: dataObject.msg, vm: vm, code: dataObject.code});
          //在文件列表页面
          if (vm.$route.name == "files-list") {
            vm.$store.commit("setSlicingCode", {code: dataObject.code, id: dataObject.meetingDatumId, processResult: dataObject.processResult});
          }
          if (vm.$route.name == "wizard-navigation") {
            //如果在向导页且步骤正好是4 肯定是文件列表页
            if (vm.$store.state.app.currentPage == 4) {
              vm.$store.commit("setSlicingCode", {code: dataObject.code, id: dataObject.meetingDatumId});
            } else {
              //如果步骤不为4 但是navigationItemId 为4 证明是刷新后的第四步 也是文件列表页。
              if (vm.$route.query.navigationItemId == 4 && vm.$store.state.app.currentPage == -1) {
                vm.$store.commit("setSlicingCode", {code: dataObject.code, id: dataObject.meetingDatumId});
              }
            }
          }
          //新增会议步骤里的会议资料
          if (vm.$route.name == "wizard-template") {
            if (vm.$store.state.app.currentPage == 4) {
              vm.$store.commit("setSlicingCode", {code: dataObject.code, id: dataObject.meetingDatumId});
            }
          }
        }
        break;
        // 切图回调进度
      case 'slicingProgress': {
        // 在文件列表页面
        if (vm.$route.name === "files-list") {
          let nowVue = vm.$store.state.app.nowVue;
          // 会议资料id
          let meetingDatumId = dataObject.meetingDatumId;
          // 页面数据
          let processedPage = dataObject.processedPage;
          // 总页数据
          let totalPage = dataObject.totalPage;
          // 百分比
          let percent = parseInt(processedPage * 100 / totalPage);
          // 循环找到对应的会议资料数据
          for (let i = 0; i < nowVue.tableData1.length; i++) {
            // 每个资料数据
            let meetingDatum = nowVue.tableData1[i];
            // 判断资料页数据等于列表中的
            if (meetingDatum.pkid === meetingDatumId && meetingDatum.progress < percent) {
              // 附加百分比
              nowVue.tableData1[i].progress = percent;
              break;
            }
          }
        } else if (vm.$route.name === "wizard-template" && vm.$store.state.app.currentPage === 4) {
          // 在其他页面
          let nowVue = vm.$store.state.app.nowVue;
          // 获取会议资料id
          let meetingDatumId = dataObject.meetingDatumId;
          // 获取页数据
          let processedPage = dataObject.processedPage;
          // 获取总页数
          let totalPage = dataObject.totalPage;
          // 获取百分比
          let percent = parseInt(processedPage * 100 / totalPage);
          // 循环数据
          for (let i = 0; i < nowVue.data.length; i++) {
            // 得到每个数据
            let meetingDatum = nowVue.data[i];
            // 判断资料数据与处理的资料数据一致
            if (meetingDatum.pkid === meetingDatumId && meetingDatum.progress < percent) {
              // 赋值百分比
              nowVue.data[i].progress = percent;
              break;
            }
          }
        }
      }
        break;
      // 有其他人员审批刷新审批页面
      case "afterTheAudit":
        // 当前人员id
        var userId = parseInt(sessionStorage.getItem("setUserId"));
        // 判断发送命令的人员不等于当前的人员并且审核人员id集合中含有当前人员id
        if (visitorUserId !== userId && dataObject.auditUserIds.indexOf(userId) !== -1) {
          console.log("收到afterTheAudit命令", dataObject);
          // 判断当前页面是在我的审核页面
          if (pageName.toLowerCase().indexOf("meeting-list") >= 0) {
            // 刷新列表列表
            window.refreshCurrentPageData();
            // 判断审批模态框是否打开并且打开的是其他人员审批过的
            if (window.getAuditModal() && window.getSelectedMeetingId() === dataObject.meetingId){
              // 则关闭当前模态框
              window.setAuditModal(false);
            }
          }
        }
        break;
           // 电量提醒阈值
      case "nodeBatteryNotice":
        if(isNotice){
          // 暂时注释，等待终端领用功能完善后放开使用
          // vm.$Notice.warning({
          //   duration: 0,
          //   title: '提醒',
          //   name:"batteryTip",
          //   render: h => {
          //     return h('span', {
          //       style: {
          //         cursor: 'pointer'
          //       },
          //       on:{
          //         click: () =>{
          //           if(vm.$route.name=='monitoring'){
          //           } else {
          //             vm.$router.push({
          //               name: 'monitoring',
          //               // 跳转参数设置是审核页面参数
          //               query: {
          //                 // 跳转列表标识，用于返回的时候跳转到那个列表中
          //                 jump: "battaryLow",
          //               },

          //             })

          //           }
          //           isNotice = true
          //           vm.$Notice.close("batteryTip");
          //         }
          //       }
          //     },`您有设备电量不足提醒，请点击查看`)

          //   },
          //   onClose: () => {
          //     isNotice = true
          //   }
          // })
          isNotice = false
        }

        break;

      case "meetingPackage":
        let meetingPackageStatus = JSON.parse(sessionStorage.getItem("emums")).meetingPackageStatus;
        if (!Window.meetlingListPageTableData || Window.meetlingListPageTableData.length == 0) {
          return
        }
        Window.meetlingListPageTableData.map((item)=>{
          if (item.pkid == dataObject.meetingId && dataObject.packageStatus == meetingPackageStatus.packaged) {
            vm.$Message.success("导出文件生成成功！")
            item.meetingPackageStatus = meetingPackageStatus.packaged;
          }
        })
        break;
      default:
        break;

    }
  }
}

//生成一个随机数
function randomCode() {
  // 生成一个随机数并存入浏览器session中，不关闭浏览器则持久性定值
  var random;
  if (sessionStorage.getItem('socketCode') != null) {
    random = sessionStorage.getItem('socketCode');
  } else {
    // 时间戳加随机数
    random = new Date().getTime() + Math.random();
    sessionStorage.setItem('socketCode', random);
  }
  return random;
}



// WEBPACK FOOTER //
// ./src/libs/websocket.js